import request from "axios"
import Cache from "./cache"
// request.defaults.withCredentials=true;
const GET = "get"
const POST = "post"
const PUT = "put"
export default {
  /**
   * 发送请求
   */
  _doXhr: function(conf, callback) {
    request(conf)
      .then(function(res) {
        let error = null
        if (res.status === 200) {
          res = res.data
        } else {
          error = res.statusText
        }
        if (res.code && res.code !== 200) {
          console.warn(conf.url, res)
          res.msg = res.msg || res.message || res.data
          // res.data = res.data
          // error = res.msg
        }
        callback && callback(error, res)
      })
      .catch(error => {
        let response = error.response || {
          status: -99999,
          statusText: "unknown error",
        }
        if (response.status === 401 || response.status === 403) {
          // window.location.hash = '/auth'
        }
        callback && callback(response.data || response)
      })
  },

  request: function(conf, withHeader, cacheOption) {
    // if (withHeader) {
    //   let { potoken } = Env.getUser()
    //   conf.headers = { token: potoken, Authorization: potoken }
    // }
    // console.log(conf)

    // let d = new Util.Deferred()
    let noCacheValue = true
    let needCache = false
    return new Promise((resolve, reject) => {
      if (cacheOption && cacheOption.key) {
        needCache = true
        let now = +new Date()
        let store = cacheOption.store || window["sessionStorage"]
        let key = cacheOption.key
        let resCache = Cache.get(store, key)
        if (cacheOption.fromCache && resCache && resCache.expire >= now) {
          noCacheValue = false
          window.setTimeout(function() {
            // fix react setstate in constructor
            resolve(resCache.data)
          }, 10)
        }
      }
      if (noCacheValue) {
        this._doXhr(conf, function(err, res) {
          if (err) {
            reject(err)
          } else {
            if (needCache) {
              let now = +new Date()
              Cache.set(
                cacheOption.store || window["sessionStorage"],
                cacheOption.key,
                {
                  data: res,
                  expire: now + cacheOption.expire * 1000,
                }
              )
            }

            resolve(res)
          }
        })
      }
    })

    // return d
  },
  get: function(url, param, options) {
    let cf = {
      method: GET,
      url: url,
      params: param,
    }
    return this.request(cf, true, options)
  },

  post: function(url, param, options) {
    let cf = {
      method: POST,
      url: url,
      data: param,
    }
    return this.request(cf, true, options)
  },
  put: function(url, param) {
    let cf = {
      method: PUT,
      url: url,
      data: param,
    }
    return this.request(cf, true)
  },
}
